import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, rgba } from 'polished';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';

interface Props {
  isOpen: boolean;
  isMobile?: boolean;
  filterData: any;
}

function LinksFilter({
  isOpen,
  isMobile = false,
  filterData: { links },
}: Props) {
  return (
    <>
      {isOpen && (
        <FilterDropdown
          hasPaddBottom={links && links.length > 7}
          isMobile={isMobile}
        >
          {links &&
            links.map(link => (
              <StyledLink key={link.url} to={link.url}>
                {' '}
                {link.name}
              </StyledLink>
            ))}
        </FilterDropdown>
      )}
    </>
  );
}

const FilterDropdown = styled(FlexCol)<{
  isMobile: boolean;
  hasPaddBottom: boolean;
}>`
  margin-top: ${({ isMobile }) => (isMobile ? 0 : rem(32))};
  max-height: ${({ isMobile }) => (isMobile ? '100%' : rem(265))};
  overflow: ${({ isMobile }) => (isMobile ? 'initial' : 'scroll')};
  overflow-x: hidden;
  padding: ${({ isMobile }) => (isMobile ? `${rem(8)} ${rem(16)}` : 0)};
  /* background: ${({ theme }) =>
    `linear-gradient(white 90%,${theme.colors.primary})}`}; */
padding-bottom: ${({ hasPaddBottom }) => (hasPaddBottom ? rem(32) : 0)};

  ::-webkit-scrollbar {
    width: ${rem(2)};
    border-radius: 2px;
  }
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.sliderRailColor};
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.primary};
  }
`;

const StyledLink = styled(Link)`
  background-color: ${({ theme }) => rgba(theme.colors.tertiary, 0.04)};
  color: ${({ theme }) => theme.colors.tertiary};
  padding: ${rem(16)};
  line-height: ${rem(18)};
  margin-bottom: ${rem(2)};
  text-decoration: none;
  font-weight: 400;
  font-size: ${rem(14)};
  border-radius: ${rem(4)};
  font-family: ${({ theme }) => theme.font.primary};

  &:hover {
    text-decoration: underline;
    background-color: ${({ theme }) => theme.colors.tertiary};
    color: ${({ theme }) => theme.colors.white};
    transition: all 0.15s ease-in;
  }
`;

export { LinksFilter as SanitasLinksFilter };
